import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosConfig from '../../utils/axiosConfig';
import { getDeviceTimeZone } from '../../utils';

const COURSES_API_BASE_URL = '/appointment';
export const getDayAvailability = createAsyncThunk('appointment/day/availability', async ({
	day, profile, isSchedule= false, newWorkHours= []
}, { rejectWithValue }) => {
	try {
		const response = await axiosConfig.post(`${COURSES_API_BASE_URL}/available`, {
			selectedDate: day,
			tutorId: profile,
			userTimezone: getDeviceTimeZone(),
			isSchedule,
			newWorkHours: {
				days: newWorkHours
			}
		});

		return response.data
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const getCalendarInfo = createAsyncThunk('appointment/calendarinfo', async ({
	timezone, profile
}, { rejectWithValue }) => {
	try {
		const response = await axiosConfig.post(`${COURSES_API_BASE_URL}/calendarinfo`, {
			timezone: timezone,
			tutorId: profile,
		});

		return response.data
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const getSudentCalendarInfo = createAsyncThunk('appointment/student/calendarinfo', async ({
	profile, timezone, startDate, endDate
}, { rejectWithValue }) => {
	try {
		const response = await axiosConfig.post(`${COURSES_API_BASE_URL}/student/calendarinfo`, {
			timezone: timezone ?? getDeviceTimeZone(),
			profile: profile,
			startDate,
			endDate,
		});

		return response.data
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const getTutorCalendarInfo = createAsyncThunk('appointment/tutor/calendarinfo', async ({
	profile, timezone, startDate, endDate
}, { rejectWithValue }) => {
	try {
		const response = await axiosConfig.post(`${COURSES_API_BASE_URL}/tutor/calendarinfo`, {
			timezone: timezone ?? getDeviceTimeZone(),
			startDate,
			endDate,
		});

		return response.data
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const reviewPayment = createAsyncThunk('appointment/paymentreview', async ({
	result, appointment
}, { rejectWithValue, getState }) => {
	try {
		const response = await axiosConfig.post(`${COURSES_API_BASE_URL}/paymentreview`, {
			result: result,
			appointment: appointment, 
			admin: getState().profile.currentProfile._id
		});

		return response.data
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const createOrder = createAsyncThunk('appointment/create', async ({events, tutor, student, lang}, { rejectWithValue }) => {
	try {
		const response = await axiosConfig.post(`${COURSES_API_BASE_URL}/create`, {
			events: events,
			tutor: tutor,
			student: student,
			lang: lang
		});

		return response.data
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const getPaymentLink = createAsyncThunk('appointment/payment', async (data, { rejectWithValue }) => {
	try {
		const response = await axiosConfig.post(`${COURSES_API_BASE_URL}/create`, {
			events: data
		});

		return response.data
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const getOrderData = createAsyncThunk('appointment/order/data', async (id, { rejectWithValue }) => {
	try {
		const response = await axiosConfig.post(`${COURSES_API_BASE_URL}/order`, {
			id: id
		});

		return response.data
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const cancelSingleAppointment = createAsyncThunk('appointment/cancel/appointment', async ({id, reason, message}, { rejectWithValue, getState }) => {
	try {
		const response = await axiosConfig.post(`${COURSES_API_BASE_URL}/cancel`, {
			id: id,
			reason: reason,
			message: message,
			profile: getState().profile.currentProfile._id
		});

		return response.data
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const cancelAppointmentRange = createAsyncThunk('appointment/range/cancel', async (ids, { rejectWithValue, getState }) => {
	try {
		const response = await axiosConfig.post(`${COURSES_API_BASE_URL}/range/cancel`, {
			events: ids,
			profile: getState().profile.currentProfile._id
		});

		return response.data
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const activateRange = createAsyncThunk('appointment/range/enable', async ({start, end}, { rejectWithValue, getState }) => {
	try {
		const response = await axiosConfig.post(`${COURSES_API_BASE_URL}/range/enable`, {
			tutor: getState().profile.currentProfile._id,
			start: start,
			end: end
		});

		return response.data
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const disableRange = createAsyncThunk('appointment/range/disable', async ({start, end, events, action, reason}, { rejectWithValue, getState }) => {
	try {
		const response = await axiosConfig.post(`${COURSES_API_BASE_URL}/range/disable`, {
			tutor: getState().profile.currentProfile._id,
			start: start,
			end: end,
			events: events,
			action: action,
			reason: reason
		});

		return response.data
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const rescheduleRange = createAsyncThunk('appointment/range/reschedule', async ({start, end, events, timezone}, { rejectWithValue, getState }) => {
	try {
		const response = await axiosConfig.post(`${COURSES_API_BASE_URL}/range/reschedule`, {
			profile: getState().profile.currentProfile._id,
			start: start,
			end: end,
			events: events,
			timezone: timezone,
		});

		return response.data
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const getAppointmentList = createAsyncThunk('appointment/get/appointment', async ({profile = undefined, role = undefined}, { rejectWithValue, getState }) => {
	try {
		const userRole = role ? role : getState().profile.currentProfile.role;
		const response = await axiosConfig.post(`${COURSES_API_BASE_URL}/get/appointment`, {
			role: userRole,
			timezone: getDeviceTimeZone(),
		});
		return response.data
		
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const getSingleAppointment = createAsyncThunk('appointment/single', async (id, { rejectWithValue, getState }) => {
	try {
		const response = await axiosConfig.post(`${COURSES_API_BASE_URL}/single`, {
			profile: getState().profile.currentProfile._id,
			timezone: getDeviceTimeZone(),
			id: id
		});

		return response.data
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const rescheduleSingleAppointment = createAsyncThunk('appointment/single', async (data, { rejectWithValue, getState }) => {
	try {
		const response = await axiosConfig.post(`${COURSES_API_BASE_URL}/reschedule`, {
			profile: getState().profile.currentProfile._id,
			timezone: getDeviceTimeZone(),
			data: data
		});

		return response.data
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const approveSingleAppointment = createAsyncThunk('appointment/approve/appointment', async ({id}, { rejectWithValue, getState }) => {
	try {
		const response = await axiosConfig.post(`${COURSES_API_BASE_URL}/approve`, {
			id: id,
			profile: getState().profile.currentProfile._id
		});

		return response.data
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const reportSingleAppointment = createAsyncThunk('appointment/report/appointment', async ({id, reason, more, file}, { rejectWithValue, getState }) => {
	try {
		let formData = new FormData();

		formData.append("id", id);
		if(file)
			formData.append("file", file);
		formData.append("reason", reason);
		formData.append("more", more);
		formData.append("profile", getState().profile.currentProfile._id);
		const response = await axiosConfig.post(`${COURSES_API_BASE_URL}/report`, formData, {
			withCredentials: false,
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
		
		return response.data;

	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});


export const setWeekSchedule = createAsyncThunk('appointment/workschedule', async ({
	days, appointments
}, { rejectWithValue, getState }) => {
	try {
		const response = await axiosConfig.post(`${COURSES_API_BASE_URL}/workschedule`, {
			days: days,
			profile: getState().profile.currentProfile._id,
			timezone: getDeviceTimeZone(),
			appointments: appointments ? appointments : []
		});
		return response.data
	} catch (error) {
		const status = error.response?.status;
		const data = error.response?.data;
		if (status === 409 || status === 300 || data?.code === 'SCHEDULE_CONFLICT') {
			return {
				existAppointments: true,
				list: data.appointments,
			};
		}

		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const getSchedule = createAsyncThunk('appointment/get/workschedule', async (_, { rejectWithValue, getState }) => {
	try {
		const response = await axiosConfig.post(`${COURSES_API_BASE_URL}/getschedule`, {
			profile: getState().profile.currentProfile._id,
			timezone: getDeviceTimeZone(),
		});

		return response.data
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const getCallToken = createAsyncThunk('appointment/get/callToken', async (id, { rejectWithValue }) => {
	try {
		const response = await axiosConfig.post(`${COURSES_API_BASE_URL}/token`, { id });

		return response.data
	} catch (error) {
		const message = error?.response?.data?.message;
		const normalizedError = Array.isArray(message) ? message.join(", ") : (message || error.message);
		return rejectWithValue({
			error: normalizedError
		});
	}
});